import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionTrucking/SectionTrucking.module.scss';

const cn = classNames.bind(styles);

const SectionTrucking = (): ReactElement => {
  return (
    <section className={cn('trucking')}>
      <div className={cn('container')}>

        <h2 className={cn('trucking__heading')}>
          The Trucking Side of Demurrage and Detention
        </h2>

        <div className={cn('trucking__content')}>

          <div className={cn('trucking__content-container')}>
            <p className={cn('trucking__paragraph')}>
              The impact of Demurrage and Detention is not limited to the maritime
              leg of the journey. It significantly affects the trucking side of logistics,
              directly impacting trucking companies and their drivers. Detention time for
              truckers occurs when they spend an unreasonable amount of time waiting to
              load or unload at a warehouse, distribution centre, or a port.
            </p>
            <p className={cn('trucking__paragraph')}>
              According to experts in the industry, in the past, before Electronic
              Logging Devices (ELD) became mandatory, truck drivers could often mask
              detention time.
            </p>
            <p className={cn('trucking__paragraph')}>
              However, the new ELD requirements precisely record drivers' hours, leaving
              no room for manipulation and bringing more attention to this previously
              hidden issue. Shippers and receivers are now pressured to reassess their
              practices and rethink the amount of time they detain drivers at the dock.
            </p>
            <p className={cn('trucking__paragraph')}>
              Detention not only costs the trucking company money (often transferred to
              freight forwarders) but also negatively impacts driver satisfaction and
              retention within an industry already plagued with driver shortages.
              It's a lose-lose situation.
            </p>
          </div>

          <div className={cn('trucking__content-container')}>
            <div className={cn('trucking__paragraph')}>
              Freight forwarders play a key role in minimising detention time by:
              <ul className={cn('trucking__list')}>
                <li className={cn('trucking__list-item')}>
                  Providing accurate and timely pick-up and delivery information to the trucking companies.
                </li>
                <li className={cn('trucking__list-item')}>
                  Optimising schedules to ensure truck drivers are not left waiting unnecessarily.
                </li>
              </ul>
            </div>
            <p className={cn('trucking__paragraph')}>
              By addressing detention on the trucking side, you contribute to a more
              efficient and cost-effective supply chain while promoting driver well-being.
            </p>
            <p className={cn('trucking__paragraph')}>
              In the global logistics market, Demurrage and Detention remain persistent
              challenges, but they are manageable with awareness and proactive strategies.
              These charges significantly impact freight forwarders, and understanding their
              intricacies is vital for smooth and profitable operations.
            </p>
            <p className={cn('trucking__paragraph')}>
              By staying informed, embracing technology, prioritising clear communication, 
              and choosing the right partners, you can navigate the complex world of 
              Demurrage and Detention fees, minimising their impact on your business and 
              contributing to a healthier and more efficient supply chain.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionTrucking;